import { Save } from "@mui/icons-material";
import {
  Avatar,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";

import React from "react";

const PoRowForm = ({
  id,
  title,
  setTitle,
  alterName,
  setAlterName,
  store,
  setStore,
  category,
  setCategory,
  price,
  setPrice,
  cost,
  setCost,
  url,
  SetUrl,
  handleClose,
  handleOnSubmitRow,
  buttonTitle,
}) => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={1} sm={12}>
        <Typography variant="h6">{title}</Typography>
      </Grid>
      <Grid item xs={1} sm={12}>
        <Avatar
          alt={title}
          src={url}
          sx={{ width: 200, height: 200, gap: 1, mt: 1, p: 0 }}
          style={{
            transform: "translate(118px, 0%)",
            top: "10px",
          }}
        />
      </Grid>
      <Grid item xs={1} sm={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          type="text"
          color="primary"
          label="Quantity"
          autoComplete="off"
          InputLabelProps={{ shrink: true }}
          value={store}
          onChange={(e) => {
            setStore(e.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          type="text"
          color="primary"
          label="Cost"
          autoComplete="off"
          InputLabelProps={{ shrink: true }}
          value={cost}
          onChange={(e) => {
            setCost(e.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          type="text"
          color="primary"
          label="Sale"
          autoComplete="off"
          InputLabelProps={{ shrink: true }}
          value={price}
          onChange={(e) => {
            setPrice(e.target.value);
          }}
        />
      </Grid>

      <Grid
        item
        xs={1}
        sm={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <IconButton
          onClick={handleOnSubmitRow}
          variant="outlined"
          color="primary"
        >
          <Save sx={{ width: 30, height: 30 }} />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default PoRowForm;
